<app-breadcrumb [master]="'Administracja'" [parentName]="'Użytkownicy'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-department-details-view *ngIf="!modify" [department]="department" (modifyClicked)="modify = true"></app-department-details-view>
    <app-department-add *ngIf="modify" [department]="department" (closeModification)="modify = false; loadDepartment()"></app-department-add>
  </mat-tab>
  <mat-tab label="Pracownicy">
    <div fxLayout="column" fxLayoutGap="15px" class="employee-list">
      <table mat-table [dataSource]="employeesDataSource">

        <!-- Position Column -->
        <ng-container matColumnDef="username">
          <th mat-header-cell *matHeaderCellDef> Nazwa </th>
          <td mat-cell *matCellDef="let element">
            <div class="circular-image">
              <img class="circular-image small-avatar user-list-avatar"
                   [src]="element.avatar ? '/rest/sso/api/user/' + element.uuid + '/avatar'
               : '/assets/avatar.png'"
                   alt="Zdjęcie"/>
            </div>
            <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.uuid]">{{element.username}}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="active">
          <th mat-header-cell *matHeaderCellDef> Aktywny </th>
          <td mat-cell *matCellDef="let element">
            {{element.active ? 'Tak' : 'Nie'}}
          </td>
        </ng-container>

        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef> Imię </th>
          <td mat-cell *matCellDef="let element">
            {{element.firstName}}
          </td>
        </ng-container>

        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef> Nazwisko </th>
          <td mat-cell *matCellDef="let element">
            {{element.lastName}}
          </td>
        </ng-container>

        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef> Numer telefonu </th>
          <td mat-cell *matCellDef="let element">
            {{element.phone | phone}}
          </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef> Email </th>
          <td mat-cell *matCellDef="let element">
            {{element.email}}
          </td>
        </ng-container>

        <ng-container matColumnDef="position">
          <th mat-header-cell *matHeaderCellDef> Stanowisko </th>
          <td mat-cell *matCellDef="let element">
            {{element.position}}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <mat-paginator [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
  </mat-tab>
  <mat-tab label="Uprawnienia">

    <div *ngIf="departmentObject" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column" class="department-permissions">
      <div fxFlex="50" fxFlex.lt-md="100">
        <mat-card>
          <h3>Uprawnienia przełożonego</h3>

          <app-permissions [disabled]="!(userPermissions | async).department.write" [permissionsForm]="supervisorPermissionsForm"
                           [currentPermissions]="departmentObject.supervisorPermissions"></app-permissions>

          <button *ngIf="(userPermissions | async).department.write" (click)="saveSupervisorPermissions()"
                  mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
        </mat-card>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100">
        <mat-card>
          <h3>Uprawnienia pracownika</h3>

          <app-permissions [disabled]="!(userPermissions | async).department.write" [permissionsForm]="employeePermissionsForm"
                           [currentPermissions]="departmentObject.employeePermissions"></app-permissions>

          <button *ngIf="(userPermissions | async).department.write" (click)="saveEmployeePermissions()"
                  mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
        </mat-card>
      </div>
    </div>

  </mat-tab>
  <mat-tab label="Uprawnienia aplikacji">
    <div *ngIf="departmentObject" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column" class="department-permissions">

      <div fxFlex="50" fxFlex.lt-md="100">
        <mat-card>
          <h3>Uprawnienia aplikacji przełożonego</h3>

          <app-application-permission
            [applicationPermissionsForm]="supervisorApplicationPermissionsForm"
            [currentApplicationPermissions]="getApplicationPermissionsByAssignmentType('supervisor')"
            [assignmentContext]="'department'"
            [disabled]="!(userPermissions | async).department.write">
          </app-application-permission>

          <button
            *ngIf="(userPermissions | async).department.write"
            (click)="saveSupervisorApplicationPermissions()"
            mat-stroked-button
            color="primary">
            <mat-icon>save</mat-icon>
            <span> Zapisz</span>
          </button>
        </mat-card>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100">
        <mat-card>
          <h3>Uprawnienia aplikacji pracownika</h3>

          <app-application-permission
            [applicationPermissionsForm]="employeeApplicationPermissionsForm"
            [currentApplicationPermissions]="getApplicationPermissionsByAssignmentType('employee')"
            [assignmentContext]="'department'"
            [disabled]="!(userPermissions | async).department.write">
          </app-application-permission>

          <button
            *ngIf="(userPermissions | async).department.write"
            (click)="saveEmployeeApplicationPermissions()"
            mat-stroked-button
            color="primary">
            <mat-icon>save</mat-icon>
            <span> Zapisz</span>
          </button>
        </mat-card>
      </div>

    </div>
  </mat-tab>
</mat-tab-group>
